/* eslint-disable react/jsx-props-no-spreading */
import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as reportGeneration from '../../../../../redux/reportGeneration';
import ProjectSidebar from '../projectLevel/Sidebar';
import ReleaseGroupSidebar from '../releaseGroupLevel/Sidebar';
import type { ReportGenerationParams } from '../../shared/types';

type Props = {
  params: ReportGenerationParams;
  resetFormat: () => void;
};

const ProjectLevelSidebar: VoidFunctionComponent<Props> = (props: Props) => {
  const projectType = useSelector(reportGeneration.selectors.getProjectType);

  return projectType === 'project' ? (
    <ProjectSidebar {...props} />
  ) : (
    <ReleaseGroupSidebar {...props} />
  );
};

export default ProjectLevelSidebar;
